import { useMemo } from "react";

export default function Question({ question, dispatch, answer, decodeHtml }) {
  const hasAnswered = answer !== null;

  const options = useMemo(() => {
    const opt = [...question.incorrect_answers];
    const index = Math.floor(Math.random() * (opt.length + 1));
    opt.splice(index, 0, question.correct_answer);
    return opt;
  }, [question]);

  return (
    <div>
      <h4>{decodeHtml(question.question)}</h4>
      <div className="options">
        {options.map((option) => (
          <button
            className={`btn btn-option ${option === answer ? "answer" : ""} ${
              hasAnswered
                ? option === question.correct_answer
                  ? "correct"
                  : "wrong"
                : ""
            }`}
            key={option}
            disabled={hasAnswered}
            onClick={() => dispatch({ type: "newAnswer", payload: option })}
          >
            {decodeHtml(option)}
          </button>
        ))}
      </div>
    </div>
  );
}
